const SubAbasKits = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/secsaude/produtosdaf/kits/ficha/${id}/dadosgerais`,
  },
];

export default SubAbasKits;
